import { index, Options } from 'shared/assets/styles';
import styled, { css } from 'styled-components';

import { Densities } from './types';

export const Container = styled.div<{
  $hideBorder: boolean;
  $borderColor?: string;
}>`
  border-bottom: ${({ theme, $hideBorder, $borderColor }) =>
    $hideBorder
      ? 'none'
      : `1px solid ${$borderColor ?? theme.palette.divider}`};

  /* background: red; */
`;

export const ContentContainer = styled.div<{
  $isElectronMac: boolean;
  $menuDisplayed: boolean;
  $smallLeftPadding: boolean;
  $hideBorder: boolean;
  $density: Densities;
}>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  position: sticky;
  top: 0;
  z-index: ${index(Options.TOPBAR)};

  padding: ${({ theme, $smallLeftPadding, $density }) => {
    const vertical = theme.spacing($density === Densities.Compact ? 2.5 : 3);

    return `${vertical} ${theme.spacing(3)} ${vertical} ${theme.spacing($smallLeftPadding ? 3 : 5)}`;
  }};

  color: ${({ theme }) => theme.palette.grey[700]};

  ${({ theme, $isElectronMac, $menuDisplayed, $smallLeftPadding }) =>
    $isElectronMac &&
    css`
      -webkit-app-region: drag;
      padding-left: ${theme.spacing(19)};

      ${$menuDisplayed &&
      css`
        ${theme.breakpoints.up(theme.breakpoints.values.md)} {
          padding-left: ${theme.spacing($smallLeftPadding ? 3 : 5)};
        }
      `};
    `};

  ${({ $hideBorder, $density }) =>
    $hideBorder &&
    $density === Densities.Default &&
    css`
      padding-bottom: ${({ theme }) => theme.spacing(1)};
    `};
`;

export const SmallScreenIconButton = styled.div`
  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.md)} {
    display: none;
  }

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const SmallScreenUpIconButton = styled.div`
  display: none;

  ${({ theme }) => theme.breakpoints.up(theme.breakpoints.values.md)} {
    display: block;
  }
`;

export const Content = styled.div`
  flex: 1;
`;

export const MobileNavigation = styled.div`
  display: none;
  padding: ${({ theme }) => `${theme.spacing(3)} ${theme.spacing(4)}`};

  border-top: 1px solid ${({ theme }) => theme.palette.divider};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: block;
    `}
`;
